import $api from "../http";
import { ISubscription } from "../models/Subscription";

class SubscriptionServiceClass {
  async getAllSubscriptions() {
    return await $api.get<ISubscription[]>(`api/subscriptions/get-all-for-user`);
  }
}

export const SubscriptionService = new SubscriptionServiceClass();
